module.exports = __webpack_public_path__ + "static/media/mars.f147f3b9.svg";